'use client';
import { useEffect, useState } from 'react';

function formatPositionType(value) {
  if (!value) return '';
  return value
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

export default function RecruiterboxWidget() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const url = `https://jsapi.recruiterbox.com/v1/openings?client_name=${encodeURIComponent(process.env.NEXT_PUBLIC_RECRUITERBOX_CLIENT_NAME)}&limit=250`;
    fetch(url, { headers: { Accept: 'application/json' } })
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : (data?.objects ?? []);
        setJobs(list);
      })
      .catch((err) => setError(err?.message || 'Failed to load positions.'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-gray-500">Loading positions…</p>;
  if (error)
    return <p className="text-red-600">Unable to load positions. Please try again later.</p>;
  if (jobs.length === 0) return <p className="text-gray-500">No open positions at this time.</p>;

  return (
    <div
      aria-label="Career page job listings"
      className="text-lg sm:text-xl lg:text-paragraphLarge"
    >
      <ul className="m-0 flex list-none flex-col gap-4 p-0">
        {jobs.map((job) => {
          const locationStr = [job.location?.city, job.location?.state, job.location?.country]
            .filter(Boolean)
            .join(', ');
          const meta = [locationStr, formatPositionType(job.position_type)]
            .filter(Boolean)
            .join(' · ');

          return (
            <li
              key={job.id}
              className="block overflow-hidden rounded-md border border-brittainLightGray transition-colors hover:border-brittainRed/40"
            >
              <a
                href={job.hosted_url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col gap-2 p-4 text-inherit no-underline transition-colors hover:bg-[#D9D9D926] sm:flex-row sm:items-center sm:justify-between"
              >
                <div className="flex flex-col gap-0.5">
                  <span className="font-semibold text-brittainRed hover:underline">
                    {job.title}
                  </span>
                  {meta && <span className="text-sm text-gray-600">{meta}</span>}
                </div>
                <span className="shrink-0 text-sm font-medium text-brittainRed">
                  View & apply →
                </span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
